import { render, staticRenderFns } from "./IconChip.vue?vue&type=template&id=2b624ed1&scoped=true&"
import script from "./IconChip.vue?vue&type=script&lang=ts&"
export * from "./IconChip.vue?vue&type=script&lang=ts&"
import style0 from "./IconChip.vue?vue&type=style&index=0&id=2b624ed1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b624ed1",
  null
  
)

export default component.exports